import { Space, Tag } from 'antd';
import {
  eSignContractStatusColors,
  eSignContractStatusLabels,
  stockAccountSourceColors,
  stockAccountStatusColors,
} from 'apps/investment/constants/stock-accounts';
import { DataTableColumnHeader } from 'common/data-table-column-header';
import OnlineTooltip from 'common/online-tooltip';
import { capitalize } from 'lodash';
import { booleanCell, dateTimeCell, linkCell } from 'utils/cell-formatter';
import { formatDateTime } from 'utils/formatDate';

export const columnsGenerator = () => [
  {
    accessorKey: 'id',
    header: '',
    cell: ({ getValue }) =>
      linkCell({ getValue, path: '/investment/stock-accounts' }),
  },
  {
    accessorKey: 'created_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Created" />
    ),
    cell: dateTimeCell,
  },
  {
    header: 'User',
    accessorKey: 'user_id',
    cell: ({ row }) => (
      <Space>
        <OnlineTooltip
          minimal
          isOnline={row.original.is_online}
          lastLoginAt={row.original.last_login_at}
        />
        <div>{row.original.full_name || row.original.email}</div>
      </Space>
    ),
  },
  {
    accessorKey: 'account_number',
    header: 'Tài khoản',
  },

  {
    accessorKey: 'source',
    header: 'Nguồn',
    cell: ({ getValue }) => {
      const value = getValue();

      return value ? (
        <Tag color={stockAccountSourceColors[value]}>{capitalize(value)}</Tag>
      ) : null;
    },
  },
  {
    accessorKey: 'status',
    header: 'Trạng thái',
    meta: {
      className: 'text-center',
    },
    cell: ({ row }) => {
      const record = row.original;
      return (
        <Tag color={stockAccountStatusColors[record.status]}>
          {record.status_label}
        </Tag>
      );
    },
  },
  {
    accessorKey: 'is_vsd_approved',
    header: 'VSD duyệt',
    meta: {
      className: 'text-center',
    },
    cell: booleanCell,
  },
  {
    accessorKey: 'approved_at',
    header: 'Approved',
    cell: ({ getValue }) => (getValue() ? formatDateTime(getValue()) : '-'),
  },
  {
    accessorKey: 'contract_number',
    header: 'Hợp đồng CK',
    meta: {
      className: 'text-center',
    },
  },
  {
    accessorKey: 'is_sign_contract',
    header: 'Đã ký?',
    meta: {
      className: 'text-center',
    },
    cell: booleanCell,
  },
  {
    accessorKey: 'esign_contract_status',
    header: 'Trạng thái hợp đồng',
    meta: {
      className: 'text-center',
    },
    cell: ({ getValue }) => {
      const value = getValue();

      return value ? (
        <Tag color={eSignContractStatusColors[value]}>
          {eSignContractStatusLabels[value] || value}
        </Tag>
      ) : null;
    },
  },
  {
    accessorKey: 'esign_approved_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="HĐ duyệt lúc" />
    ),
    cell: ({ getValue }) => (getValue() ? formatDateTime(getValue()) : '-'),
  },
];

export const columnsStockAccountLogs = () => [
  {
    accessorKey: 'type',
    header: 'Type',
  },
  {
    accessorKey: 'message',
    header: 'Message',
  },
  {
    accessorKey: 'request_id',
    header: 'Request ID',
  },

  {
    accessorKey: 'created_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Created" />
    ),
    cell: dateTimeCell,
  },
  {
    accessorKey: 'updated_at',
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Updated" />
    ),
    cell: dateTimeCell,
  },
];
